export const FEATURES = [
  {
    id: 'employee_dashboard',
    name: 'Employee Dashboard',
    description: 'Access to employee management and monitoring tools',
  },
  {
    id: 'visitor_management',
    name: 'Visitor and Package Management',
    description: 'Track visitors and manage package deliveries',
  },
  {
    id: 'document_library',
    name: 'Document Library',
    description: 'Centralized storage and management of documents',
  },
  {
    id: 'asset_tracking',
    name: 'Asset Tracking',
    description: 'Track and manage physical assets and inventory',
  },
  {
    id: 'emergency_alert',
    name: 'Emergency Alert System',
    description: 'Send and manage emergency notifications',
  },
  {
    id: 'expense_management',
    name: 'Expense Management',
    description: 'Track and manage expenses and budgets',
  },
]; 